import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Row, Col, Form, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import DataTable from 'react-data-table-component';
import { BiRefresh, BiPlus, BiTrash } from "react-icons/bi";
import { CiGrid41, CiViewList } from "react-icons/ci";
import { SearchIcon } from '@primer/octicons-react';
import DeleteConfirmDialog from './DeleteConfirmDialog';
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import { UserContext } from "../UserContext";
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';
import { hasAnyPerm } from '../utils/uiUtils';
import classes from './AdminPages.module.css';


const ServiceAdminListView = (props) => {

  const { t } = useTranslation(["common"]);

  const { user } = useContext(UserContext);

  const [errMsg,                  setErrMsg]                  = useState('');
  const [notFoundMsg,             setNotFoundMsg]             = useState('');

  const [deleteTarget,            setDeleteTarget]            = useState();
  const [showDeleteConfirmDialog, setShowDeleteConfirmDialog] = useState(false);
  const [errMsgDeleteConfirm,     setErrMsgDeleteConfirm]     = useState('');

  const [searchTerms,             setSearchTerms]             = useState();

  const [viewStyle,               setViewStyle]               = useState();

  // ----- Data Table stuff -----

  const [objList,   setObjList]   = useState([]);
  const [,          setLoading]   = useState(false);
  const [totalRows, setTotalRows] = useState();
  const [perPage,   setPerPage]   = useState(25);
  const [currPage,  setCurrPage]  = useState(1);
  const [sortCol,   setSortCol]   = useState(null);
  const [sortDir,   setSortDir]   = useState(null);

  const customStyles = {
    rows: {
      style: {
        minHeight: '25px', // override the row height
        fontSize: '11px',
      },
    },
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '8px',
      },
    },
  };

/*
  const conditionalRowStyles = [
    {
      when: row => row.type === 'EXTERNAL_SRV',
      style: {
        backgroundColor: '#D8E8F0'
      }
    },
    {
      when: row => row.type === 'INTERNAL_SRV',
      style: {
        backgroundColor: '#D8F0E0'
      }
    }
  ];
*/

  const columns = [
    {
      name: t("I18N_Name"),
      selector: row => row.name,
      cell: row => (
        <span style={{cursor:'pointer', color:'SteelBlue', fontSize: '13px', fontWeight:'900'}}
              onClick={() => handleObjDetails(row)}>{row.name}</span>
      ),
      grow: 2
    },
    {
      name: t("I18N_Status"),
      selector: row => row.status,
      cell: row => (
        <span style={{ minWidth:'110px', textAlign:'center', margin:'3px', padding:'7px', borderRadius:'18px',
                       color:'white', fontSize:'15px', fontWeight:"bold",
                       backgroundColor:  ((row.status === 'HEALTHY') ?     '#40C040' :
                                          (row.status === 'UNHEALTHY') ?   '#E04050' :
                                          (row.status === 'MAINTENANCE') ? '#0090D0' :
                                                                           '#A0A0A0')}}>
           {t("I18N_" + row.status)}
        </span>
      ),
    },
    {
      name: t("I18N_Status_time"),
      selector: row => formatDate(row.statusTime)
    },
    {
      name: t("I18N_Type"),
      selector: row => (
        <span style={{ fontSize:'13px', fontWeight:"bold",
                       color:  ((row.type === 'EXTERNAL_SRV') ? '#2888F0' :
                                                                '#28B020')}}>
           {t("I18N_" + row.type)}
        </span>
      )
    },
    {
      name: t("I18N_Begin_active_time"),
      selector: row => formatDate(row.beginActiveTime)
    },
    {
      name: t("I18N_End_active_time"),
      selector: row => formatDate(row.endActiveTime)
    },
/*
    {
      name: t("I18N_Last_failed_time"),
      selector: row => formatDate(row.lastFailedTime)
    },
    {
      name: t("I18N_Last_sync_time"),
      selector: row => formatDate(row.lastSyncTime)
    },
*/
    {
      name: '',
      selector: row => row.id,
      cell: row => (
        hasAnyPerm(user, ["BuildingAdminGeneralDeleteAccess"], true) ?
          <OverlayTrigger overlay={<Tooltip id="tooltip-delete-mom" style={{fontSize:'11px'}}>{t("I18N_TIP_Delete_service")}</Tooltip>}>
            <span style={{cursor:'pointer', color:'SteelBlue'}}
                  onClick={() => handleObjDelete(row)}><BiTrash size={16} />
            </span>
          </OverlayTrigger>
       : null
      ),
      grow: 0.5
    }
  ];


  const fetchObjs = async (searchTerms, sortCol, sortDir, perPage, currPage) => {

    try {
      setLoading(true);

      const res = await axiosAuth_PLATFORM_API.get("services?searchTerms=" +
                                                    ((searchTerms && (searchTerms !== null)) ? encodeURIComponent(searchTerms) : '') +
                                                    ((sortCol     && (sortCol     !== null)) ? ("&sortColumn="  + sortCol + "&sortDirection=" + sortDir) : '')  +
                                                    ((perPage     && (perPage     !== null)) ? ("&limit="       + perPage)                               : '')  +
                                                    ((currPage    && (currPage    !== null)) ? ("&offset="      + (currPage - 1) * perPage)              : ''));

      if (res.data.length === 0) {
        setNotFoundMsg("I18N_No_search_result");
      } else {
        setNotFoundMsg('');
      }

      setObjList(res.data);

      setTotalRows(res.total);
      setLoading(false);
      setErrMsg('');
    } catch (error) {
      if (!error.message || (error.message !== 'IGNORE')) {
        setErrMsg(t(translateAPIError(error)));
      }
    }
  };


  const handlePageChange = currPage => {
    setCurrPage(currPage);
    props.onSetPageState({viewStyle:   viewStyle,
                          searchTerms: searchTerms,
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    currPage});

    fetchObjs(searchTerms, sortCol, sortDir, perPage, currPage);
  };


  const handlePerRowsChange = async (newPerPage) => {

    setPerPage(newPerPage);
    props.onSetPageState({viewStyle:   viewStyle,
                          searchTerms: searchTerms,
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     newPerPage,
                          currPage:    currPage});

    fetchObjs(searchTerms, sortCol, sortDir, newPerPage, currPage);
  };


  const handleSort = (column, sortDir) => {

    // instead of setTimeout this is where you would handle your API call.
    setSortCol (column.sortField);
    setSortDir (sortDir);

    props.onSetPageState({viewStyle:   viewStyle,
                          searchTerms: searchTerms,
                          sortCol:     column.sortField,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    1});

    fetchObjs(searchTerms, column.sortField, sortDir, perPage, 1);
  };

  const paginationComponentOptions={
          rowsPerPageText: t("I18N_Rows_per_page"),
          rangeSeparatorText: t("I18N_Pagination_page_of_total"),
          noRowsPerPage: false,
          selectAllRowsItem: false,
          selectAllRowsItemText: 'All'
        };

  // ----- END - Data Table stuff -----


  /* ### Uncomment to support auto polling ###
  const pollingRef = useRef(null);
  */

  // Initialize state
  useEffect(() => {

    setViewStyle(props.pageState.viewStyle);
    setSearchTerms(props.pageState.searchTerms);
    setSortCol(props.pageState.sortCol);
    setSortDir(props.pageState.sortDir);
    setPerPage(props.pageState.perPage);
    setCurrPage(props.pageState.currPage);

    fetchObjs(props.pageState.searchTerms, props.pageState.sortCol, props.pageState.sortDir, props.pageState.perPage, props.pageState.currPage);

    /* ### Uncomment to support auto polling ###
    const startPolling = () => {
      pollingRef.current = setInterval(() => {
        pollingFunc();
      }, 10000); // Poll every 10 seconds
    };
    startPolling();

    return () => {
      clearInterval(pollingRef.current);
    };
    */

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  /* ### Uncomment to support auto polling ###
  const pollingFunc = async () => {
    fetchObjs(1, perPage, sortCol, sortDir);
  }
  */


  const onInputChange = (e) => {
    setSearchTerms(e.target.value);
  }

  const handleSearchSubmit = (e) => {
    e.preventDefault();

    setCurrPage(1); // Reset to page 1 for a fresh search
    props.onSetPageState({viewStyle:   viewStyle,
                          searchTerms: searchTerms,
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    1});

    fetchObjs(searchTerms, sortCol, sortDir, perPage, 1);
  }


  function handleObjDetails(obj) {

    props.onSetObjDetails(obj);

    props.onUIMode('DETAILS')
  }


  // Related to Model Obj delete

  function handleObjDelete(app) {
    setDeleteTarget(app);
    setShowDeleteConfirmDialog(true);
  }

  function handleObjDeleteCancel() {
    setDeleteTarget(null);
    setErrMsgDeleteConfirm('');
    setShowDeleteConfirmDialog(false);
  }

  function handleObjDeleteSubmit() {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.delete("services/" + deleteTarget.id);

        resolve(res.data);

        if (res.status === 200) {
          setShowDeleteConfirmDialog(false);
          setErrMsgDeleteConfirm('');

          // This will also cause a reload of the list.  Change to page 1 because in case deleting
          // the last item on the last page, refreshing the old last page will cause error.
          handlePageChange(1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsgDeleteConfirm(t(translateAPIError(error)));
        }
      }
    });
  }


  // Create new obj
  const handleNewService = (e) => {
    e.preventDefault();
    props.onUIMode('NEW')
  }

  // Refresh list
  const handleRefreshList = (e) => {
    e.preventDefault();

    fetchObjs(searchTerms, sortCol, sortDir, perPage, 1);
  }


  function handleViewStyleToggle(newViewStyle) {
    if (newViewStyle !== viewStyle) {
      setViewStyle(newViewStyle);
      props.onSetPageState({viewStyle:   newViewStyle,
                            searchTerms: searchTerms,
                            sortCol:     sortCol,
                            sortDir:     sortDir,
                            perPage:     perPage,
                            currPage:    currPage});
    }
  }

  function renderService(service, index) {
    return (
      <tr key={index} style={{fontWeight:'300', borderWidth:'0px'}}>
        <td style={{borderWidth:'0px'}}>
          <div style={{ margin:'3px', minWidth:'380px', minHeight:'50px', borderRadius:'10px', display: 'flex',  alignItems: 'center',
                        backgroundColor:  ((service.type === 'EXTERNAL_SRV') ? '#D8E8F0' :
                                           (service.type === 'INTERNAL_SRV') ? '#D8F0E0' :
                                                                               '#EEE')     }}>

            <span style={{marginLeft: '20px', cursor:'pointer', color:'SteelBlue', fontSize: '13px', fontWeight:'900', }}
                  onClick={() => handleObjDetails(service)}>{service.name}
            </span>
            <span style={{ minWidth:'110px', height:'35px', textAlign:'center', marginLeft:'auto', marginRight:'20px', padding:'7px',
                           borderRadius:'18px', color:'white', fontSize:'15px', fontWeight:"bold",
                           backgroundColor:  ((service.status === 'HEALTHY') ?     '#40C040' :
                                              (service.status === 'UNHEALTHY') ?   '#E04050' :
                                              (service.status === 'MAINTENANCE') ? '#0090D0' :
                                                                             '#A0A0A0')}}>
               {t("I18N_" + service.status)}
            </span>
          </div>
        </td>
      </tr>
    )
  }


  return (
    <>
      <Card className='aaa' style={{border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)', padding:'20px 40px 20px 40px',
                                    maxWidth:'2500px', height:'850px', width:'100%'}}>
        <div style={{ display: 'flex' }}>
          <span className={classes.admin_pages__page_title}>
            {t("I18N_Service_Status")}
          </span>
          <span className={classes.admin_pages__page_title} style={{marginLeft:'20px', marginTop: '3px'}}>
            <Button size="tiny" variant="outline-secondary" id="IconView" className="mb-3"
                      style={{borderWidth:'0', backgroundColor: viewStyle === 'ICON_VIEW' ? 'lightBlue' : 'white' }}
                      onClick={() => handleViewStyleToggle('ICON_VIEW')}>
              <CiGrid41 size={18} id="IconView"style={{color:'gray'}} />
            </Button>
            <Button size="tiny" variant="outline-secondary" id="Listiew" className="mb-3"
                      style={{ marginLeft: '1px', borderWidth:'0', backgroundColor: viewStyle === 'LIST_VIEW' ? 'lightBlue' : 'white' }}
                      onClick={() => handleViewStyleToggle('LIST_VIEW')}>
              <CiViewList size={18} style={{color:'gray'}} />
            </Button>
          </span>
          <span style={{marginLeft:'auto', marginTop:'7px', color:'rgba(200,0,0)', fontSize:'12px'}}>
            {errMsg}
          </span>
          <div style={{ display: 'flex', marginLeft: '30px', marginRight: '0px', width: '250px', minWidth: '250px' }}>
            <OverlayTrigger overlay={<Tooltip id="tooltip-refresh" style={{fontSize:'11px'}}>{t("I18N_TIP_Refresh_status")}</Tooltip>}>
              <span onClick={handleRefreshList}
                    style={{ marginLeft: '0px', marginRight: '0px', marginTop: '3px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                <BiRefresh size={22} />
              </span>
            </OverlayTrigger>
            <OverlayTrigger overlay={<Tooltip id="tooltip-new_obj" style={{fontSize:'11px'}}>{t("I18N_TIP_Add_service")}</Tooltip>}>
              <span onClick={handleNewService}
                    style={{ marginLeft: '20px', marginRight: '0px', marginTop: '3px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                <BiPlus size={18} />
              </span>
            </OverlayTrigger>
            <span style={{ marginLeft: '20px', marginRight: '0px', width: '220px' }}>
              <Form onSubmit={handleSearchSubmit}>
                <Form.Group as={Row} >
                  <Col sm="9" style={{ marginRight: '5px' }}>
                    <Form.Control style={{ fontSize: '12px' }} type="text" name="searchTerms" value={searchTerms}
                                  onChange={(e) => onInputChange(e)} placeholder={t("I18N_Search_terms")} />
                  </Col>
                  <Col sm="2" style={{ padding: '5px' }}>
                    <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip-search" style={{fontSize:'11px'}}>{t("I18N_Search")}</Tooltip>}>
                      <span onClick={handleSearchSubmit} style={{ cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                        <SearchIcon size={18} />
                      </span>
                    </OverlayTrigger>
                  </Col>
                </Form.Group>
              </Form>
            </span>
          </div>
        </div>

        { (notFoundMsg && notFoundMsg !== '') ?
          <span className={classes.admin_pages__field_value} style={{marginTop:'20px'}}>
            {t(notFoundMsg)}
          </span>
        :
          viewStyle === 'LIST_VIEW' ?
          <div style={{ overflowY:'auto', fontSize:'11px', marginTop:'10px' }}>

            { objList && objList.length > 0 ?
              <DataTable
                columns={columns}
                data={objList}
                customStyles={customStyles}
                fixedHeader
                fixedHeaderScrollHeight={'700px'}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationDefaultPage={currPage}
                paginationPerPage={perPage}
                paginationRowsPerPageOptions={[25,50,100]}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                onSort={handleSort}
                sortServer
                highlightOnHover
/*
                conditionalRowStyles={conditionalRowStyles}
*/
                paginationComponentOptions={paginationComponentOptions}
                noDataComponent={t("I18N_No_search_result")}
              />
            : null
            }

          </div>
        :
          <>
            <div style={{ marginTop:'20px', height:'700px', display: 'flex', border: "none", }}>

              <Table hover responsive size="sm">
                <thead style={{color:'#686868', fontSize:'12px'}}>
                  <tr style={{borderWidth:'0px'}}>
                    <th style={{borderWidth:'0px'}}></th>
                  </tr>
                </thead>
                <tbody>
                  {objList.filter((_, index) => index % 3 === 0).map(renderService)}
                </tbody>
              </Table>

              <Table hover responsive size="sm">
                <thead style={{color:'#686868', fontSize:'12px'}}>
                  <tr style={{borderWidth:'0px'}}>
                    <th style={{borderWidth:'0px'}}></th>
                  </tr>
                </thead>
                <tbody>
                  {objList.filter((_, index) => index % 3 === 1).map(renderService)}
                </tbody>
              </Table>

              <Table hover responsive size="sm">
                <thead style={{color:'#686868', fontSize:'12px'}}>
                  <tr style={{borderWidth:'0px'}}>
                    <th style={{borderWidth:'0px'}}></th>
                  </tr>
                </thead>
                <tbody>
                  {objList.filter((_, index) => index % 3 === 2).map(renderService)}
                </tbody>
              </Table>

            </div>
            <div style={{ marginTop:'15px', height:'20px', display:'flex', verticalAlign:'middle' }}>
              <div style={{ marginLeft: '5px', fontSize: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center',}}>
                {t("I18N_Legend") + ":"}
              </div>
              <div style={{ marginLeft: '10px', minWidth:'110px', display: 'flex', justifyContent: 'center', alignItems: 'center',
                             borderRadius:'6px', backgroundColor:'#D8E8F0', fontSize:'11px'}} >
                {t("I18N_EXTERNAL_SRV")}
              </div>
              <div style={{ marginLeft: '5px', minWidth:'110px', display: 'flex', justifyContent: 'center', alignItems: 'center',
                             borderRadius:'6px', backgroundColor:'#D8F0E0', fontSize:'11px'}} >
                {t("I18N_INTERNAL_SRV")}
              </div>
            </div>
          </>
        }

        <DeleteConfirmDialog
          title={t("I18N_Service_delete_confirm")}
          show={showDeleteConfirmDialog}
          targetName={deleteTarget ? deleteTarget.name : ''}
          errMsgDeleteConfirm={errMsgDeleteConfirm}
          onCancel={handleObjDeleteCancel}
          onSubmit={handleObjDeleteSubmit}
        />

      </Card>
    </>
  );
}


export default ServiceAdminListView;
